export default __webpack_public_path__ + "media/arrow-right-2.0925bd1e.svg";